import "./CardImageFlip.css";

const CardImageFlip = ({imgFront, imgBack}) => {
    return (
       
                    <div class="product-card">
                        <div class="image-box">
                            <img src={imgFront} class="product-img front" alt="Front" />
                            <img src={imgBack} class="product-img back" alt="Back" />

                            <span class="discount-badge">30% OFF</span>


                            <div class="quick-overlay">
                                 {/* <button class="btn buy-btn">Buy Now</button> */}
                            </div>
                         </div>

                        <div class="product-info">
                            <h3 class="product-title">Elegant Ladies Handbag</h3>

                            <div class="rating">
                                ★★★★☆ <span>(4.2)</span>
                            </div>

                            <div class="price">
                                <span class="current-price">₹1,999</span>
                                <span class="original-price">₹2,899</span>
                            </div>
                            <div class="addToCart">
                                <button class="btn cart-btn">Add to Cart</button>
                            </div>
                        </div>
                    </div>
             
    );
}

export default CardImageFlip;